const isStaging = () => {
  return /staging\./.test(window.location.host)
}

export default isStaging
